import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";

const Terms = () => {
  const sectionRef = useRef(null);
  const { state } = useLocation();
  const refer = state?.refer;

  const scrollToSection = () => {
    sectionRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    if (refer) {
      scrollToSection();
    }
    // eslint-disable-next-line
  }, []);

  const TermsAndConditions = () => {
    return (
      <div
        className="terms-and-conditions"
        style={{ padding: "20px", maxWidth: "900px", margin: "auto" }}
      >
        <h1>Terms & Conditions</h1>

        <p>
          By downloading or using the app, these terms will automatically apply
          to you. You should make sure therefore that you read them carefully
          before using the app.
        </p>

        <p>
          You’re not allowed to copy, or modify the app, any part of the app, or
          our trademarks in any way. You’re not allowed to attempt to extract
          the source code of the app, and you also shouldn’t try to translate
          the app into other languages, or make derivative versions. The app
          itself, and all the trademarks, copyrights, database rights, and other
          intellectual property rights related to it, still belong to Second
          Innings.
        </p>

        <p>
          Second Innings is committed to ensuring that the app is as useful and
          efficient as possible. For that reason, we reserve the right to make
          changes to the app or to charge for its services, at any time and for
          any reason. We will never charge you for the app or its services
          without making it very clear to you exactly what you’re paying for.
        </p>

        <p>
          The Bloopzy app stores and processes personal data that you have
          provided to us, in order to provide our Service. It’s your
          responsibility to keep your phone and access to the app secure. We
          therefore recommend that you do not jailbreak or root your phone...
        </p>

        <h2>Eligibility and Responsibility</h2>
        <p>
          Before you create an account on Bloopzy, make sure you are eligible to
          use our Services.
        </p>
        <p>By using our services, you agree that:</p>
        <ul>
          <li>You are at least 18 years old</li>
          <li>
            You are legally qualified to enter a binding contract with Bloopzy
          </li>
          <li>You do not have more than one account on our Services</li>
          <li>
            You have not previously been removed from our Services by us, unless
            permitted
          </li>
          <li>
            You have not been convicted of serious crimes, including sex or
            violent offenses
          </li>
        </ul>

        <p>You agree that you will not:</p>
        <ul>
          <li>Misrepresent your identity or qualifications</li>
          <li>Use our Services for illegal or harmful purposes</li>
          <li>Harass, stalk, intimidate, defame, or mistreat any person</li>
          <li>Interfere with or damage the Services</li>
          <li>Solicit passwords or personal info from users</li>
          <li>Use another user’s account</li>
          <li>Disclose private or proprietary information without consent</li>
          <li>Use or modify our content without written consent</li>
          <li>Upload malware or compromise the app's security</li>
          <li>Use Bloopzy references in unauthorized promotions or tags</li>
          <li>Reverse engineer or decompile the app</li>
          <li>Test or scan vulnerabilities of our systems</li>
          <li>Promote or agree to any activities violating these terms</li>
        </ul>

        <h3 ref={sectionRef} id="referral">
          Game Rules
        </h3>
        <ul>
          <li>
            Bloopzy reserves the right to monitor all activities on the platform
          </li>
          <li>
            Bloopzy is not liable for rule violations or gambling activities
          </li>
          <li>
            If you no longer meet eligibility, you must delete your account
          </li>
        </ul>

        <h3>Invite Terms</h3>
        <ul>
          <li>
            Simply share the app with your friends via social media and
            encourage them to enter your referral or invite code on the referral
            screen.
          </li>
          <li>You can’t invite more than one time a single user.</li>
          <li>You should not refer yourself.</li>
          <li>You should not use multiple device or accounts for referrals.</li>
          <li>
            Should not use any other hacking or mechanisms to create fake
            referrals.
          </li>
          <li>Should not use cloning or similar activities.</li>
          <li>We will only consider genie referrals.</li>
          <li>
            Your all reward coins will be revoked and may be your account
            blocked permanently without any prior notice if we detect any fraud
            activities.
          </li>
        </ul>

        <h2>Other Services</h2>
        <p>
          The app does use third-party services that declare their own Terms and
          Conditions.
        </p>
        <p>
          <strong>Links to Terms of third-party service providers:</strong>
        </p>
        <ul>
          <li>Google Play Services</li>
          <li>Google Auth</li>
          <li>Google Analytics for Firebase</li>
          <li>Unity Ads</li>
          <li>Google Ads</li>
        </ul>

        <h2>Limitations of Responsibility</h2>
        <p>
          Certain functions of the app require an internet connection. Whether
          Wi-Fi or mobile data, Second Innings is not responsible if the app
          doesn’t work fully due to poor connection.
        </p>

        <p>
          If you use the app outside your home region, you’re responsible for
          data charges including roaming fees. Make sure you have permission
          from the bill payer to use the app.
        </p>

        <p>
          You must also ensure your device remains charged. Second Innings
          cannot take responsibility if your device is dead and you can’t use
          the Service.
        </p>

        <p>
          We rely on third parties for content accuracy. Second Innings isn’t
          liable for losses due to incorrect or delayed information.
        </p>

        <h2>App Updates and Termination</h2>
        <p>
          We may update the app at any time. If you want to keep using it, you
          must accept these updates. The app is currently available for Android,
          but requirements may change. You agree to stop using the app and
          delete it if we end the service or revoke access.
        </p>

        <h2>Changes to This Terms and Conditions</h2>
        <p>
          We may update our Terms and Conditions from time to time. Please
          review this page periodically. We will notify you of changes by
          posting the updated Terms and Conditions on this page.
        </p>

        <p>
          <strong>Effective date:</strong> 2025-06-15
        </p>

        <h2>Contact Us</h2>
        <p>
          If you have any questions or suggestions about our Terms and
          Conditions, do not hesitate to contact us.
        </p>
      </div>
    );
  };

  return (
    <div>
      <TermsAndConditions />
    </div>
  );
};

export default Terms;
